export default {
	section_banner: {
		title: {
			one: '使い方',
			two: '利用方法',
		},
	},
};
